<template>
  <section class="client">
    <header class="flex-container">
      <form @submit.prevent="handleSearchList(search)">
        <f-search v-model="search" class="input-search"></f-search>
      </form>
      <div class="keywords">
        <span v-for="(term, id) in terms" :key="id" class="term">
          <span>{{ term }}</span>
          <ab-icon icon="close" @click.native="removeTerm(id)"></ab-icon>
        </span>
      </div>
      <span class="flex-spacer"></span>
      <div v-if="userRole != 2">
        <router-link :to="{ name: 'ClientCreate' }" class="btn-action secondary">Nouveau client</router-link>
      </div>
    </header>

    <main>
      <f-table cols="4">
        <template slot="thead">
          <th>Nom de l'établissement</th>
          <th>Siège social</th>
          <th>Siren</th>
          <th v-if="user.role_id != 2"></th>
        </template>
        <template slot="tbody" v-if="clients.length">
          <tr v-for="client in clients" :key="client.id">
            <td class="main">{{ client.label }}</td>
            <td>{{ client.address_1 }}</td>
            <td>{{ client.siren }}</td>
            <td class="more" v-if="user.role_id != 2">
              <f-popover-top class="tooltip-right">
                <template slot="container"><ab-icon icon="more"></ab-icon></template>
                <template slot="list">
                  <ul>
                    <li>
                      <router-link :to="{ name: 'ClientEdit', params: { id: client.id } }" class="item"><ab-icon icon="update"></ab-icon>Modifier</router-link>
                    </li>
                    <li>
                      <span class="item" @click="showModal(client.id)"><ab-icon icon="delete"></ab-icon>Supprimer</span>
                    </li>
                  </ul>
                </template>
              </f-popover-top>
            </td>
          </tr>
        </template>
      </f-table>
    </main>

    <footer>
      <paginate
        v-model="currentPage"
        :pageCount="pageCount(clients)"
        prev-class="prev"
        next-class="next"
        :containerClass="'f-pagination'">
      </paginate>
    </footer>

    <f-modal class="modal" name="remove" height="auto" @before-open="beforeOpen">
      <section>
        <f-card>
          <main>
            <p>Confirmer la suppression du client</p>
          </main>
          <footer class="flex flex-right">
            <ab-button class="white" @click.native="closeModal">Annuler</ab-button>
            <ab-button class="danger" @click.native="removeClient">Confirmer</ab-button>
          </footer>
        </f-card>
      </section>
    </f-modal>
  </section>
</template>

<script>
  import AbButton from '@/components/form/button/ab-button.vue';
  import AbIcon from '@/components/icon/ab-icon.vue';
  import FCard from '@/components/layout/card/f-card.vue';
  import FPopoverTop from '@/components/modal/popover/f-popover-top.vue';
  import FSearch from '@/components/form/input/f-search.vue';
  import FTable from '@/components/layout/table/f-table.vue';
  import Paginate from 'vuejs-paginate';
  import paginationMixin from '@/components/mixins/pagination.js';
  import searchMixin from '@/components/mixins/search.js';
  import { mapState } from 'vuex';
  // Import error message files
  import messages from '../../../messages/messages.js';

  export default {
    name: 'ClientList',
    components: {
      AbButton,
      AbIcon,
      FCard,
      FPopoverTop,
      FSearch,
      FTable,
      Paginate,
    },
    mixins: [ paginationMixin, searchMixin ],
    mounted() {
      this.userRole = this.$store.state.user.role_id;
    },
    data() {
      return {
        search: "",
        clientId: "",
        userRole: "",
      }
    },
    computed: {
      ...mapState({ clients: function(state) { return state.clients.clients } }),
      ...mapState({ user: state => { return state.user } }),
    },
    methods: {
      getData(isNewSearch) {
        this.currentPage = isNewSearch ? 1 : this.currentPage;
        this.$store.dispatch('getClients', { terms: this.terms, page: this.currentPage, limit: 10 });
      },
      showModal(id) {
        this.$modal.show('remove', { id: id });
      },
      beforeOpen(e) {
        this.clientId = e.params.id;
      },
      closeModal() {
        this.$modal.hide('remove');
      },
      async removeClient() {
        const data = await this.$store.dispatch('deleteClient', {
          id: this.clientId,
          page: this.currentPage,
        });
        if (data) {
          this.displayToast({ message: messages.clients.ClientList.custom.success });
        }
        this.$modal.hide('remove');
        this.clientId = "";
      },
      /* search mixin */
      searchList() {
        let isNewSearch = false;
        const terms = this.$route.query.terms || [];
        if (this.search) isNewSearch = terms.indexOf(this.search) == -1;
        this.getData(isNewSearch);
        this.search = '';
      },
    },
  }
</script>

<style scoped>
  /* Header */
  .flex-container {
    display: flex;
    justify-content: flex-start;
    align-items: flex-start;
  }
  header { margin-bottom: 1.1rem; }
  .input-search {
    min-width: 23rem;
    width: 23rem;
  }
  /* Table */
  .main {
    font-size: 1.15rem;
    line-height: 1.85rem;
    color: var(--app-blue-four);
    font-weight: 600;
  }
  tr td {
    height: 4.6rem;
  }
  /* Last column */
  td.more {
    vertical-align: bottom;
    width: 5rem;
  }
  /* Footer */
  footer { margin-top: 1.1rem; }
  /* Modal */
  .modal p { color: var(--app-dark-grey); }
</style>
<style src="@/assets/styles/chips.css"></style>
<style src="@/assets/styles/pagination.css"></style>
